module.exports = __webpack_public_path__ + "img/bg-light.946ea794.png";